import React from 'react';
import BarChartIcon from '../icons/BarChartIcon';

const STATIC_FEATURES = [
  { icon: 'bar', title: 'Multi-Buyer Comparison', body: 'Check prices across all four major UK media buyers simultaneously — on one screen.', status: 'live', accent: '#00D26A' },
  { emoji: '🎯', title: 'Premium Slot Optimizer', body: 'Maximise revenue from £0.00 items by unlocking buyer premium slots at the right moment.', status: 'coming', accent: '#FFD700' },
  { emoji: '💰', title: 'Voucher Arbitrage Cycle', body: 'Convert voucher payouts into cash equivalent at ~1.12× — documented advanced strategy.', status: 'coming', accent: '#FFD700' },
  { emoji: '📸', title: 'Screenshot OCR', body: 'Upload basket screenshots and extract prices automatically — 10× faster than manual entry.', status: 'coming', accent: '#00D26A' },
  { emoji: '📴', title: 'Offline PWA Mode', body: "Scan items at charity shops without WiFi. Data syncs automatically when you're back online.", status: 'coming', accent: '#FFD700' },
];

export default function FeatureCards({ totalChecks, totalEarnings }) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {STATIC_FEATURES.map((f) => (
        <div
          key={f.title}
          className="bg-zinc-900 border border-zinc-800 rounded-lg p-6 border-t-4"
          style={{ borderTopColor: f.accent }}
        >
          <div className="text-3xl mb-3 leading-none">
            {f.icon === 'bar' ? <BarChartIcon size="1em" /> : f.emoji}
          </div>
          <h3 className="text-lg font-semibold text-white mb-2">{f.title}</h3>
          <p className="text-zinc-400 text-sm">{f.body}</p>
          <div className={`mt-4 text-sm font-medium ${f.status === 'live' ? 'text-[#00D26A]' : 'text-zinc-500'}`}>
            {f.status === 'live' ? '✓ Live' : 'Coming Soon'}
          </div>
        </div>
      ))}

      {/* Feature 6 — Earn Your Subscription (LIVE, dynamic) */}
      <div className="bg-zinc-900 border border-zinc-800 rounded-lg p-6 border-t-4 border-t-[#00D26A]">
        <div className="text-3xl mb-3">🎁</div>
        <h3 className="text-lg font-semibold text-white mb-2">Earn Your Subscription</h3>
        <p className="text-zinc-400 text-sm">
          Earn 1p per verified price point — up to 5p per fully-checked barcode. Active now.
        </p>
        <div className="mt-4 text-sm font-semibold text-[#00D26A]" data-testid="earn-your-sub-progress">
          {totalChecks} price points checked · £{totalEarnings.toFixed(2)} earned
        </div>
      </div>
    </div>
  );
}
